import { Trash2 } from 'lucide-react'
import type { ReportCardImportMatch } from '@/lib/reportCardImport'
import { AddExamButton, ImportGradeRow } from './ImportGradeRow'

function formatConfidence(confidence: number) {
  return `${Math.round(confidence * 100)} %`
}

export default function ImportReviewCard({
  item,
  onUpdate,
  onRemove,
}: {
  item: ReportCardImportMatch
  onUpdate: (
    updates: Partial<Pick<ReportCardImportMatch, 'grade' | 'exam' | 'exam2'>>
  ) => void
  onRemove: () => void
}) {
  return (
    <div className="rounded-lg border border-warm-gray-300 bg-white px-3 py-3 shadow-[0_2px_4px_0_rgba(0,0,0,0.04)]">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-sm font-semibold">{item.matchedCourseName}</div>
          {(item.notes || item.confidence < 0.9) && (
            <div className="mt-0.5 text-xs text-warm-gray-700">
              {item.notes ?? `Sikkerhet: ${formatConfidence(item.confidence)}`}
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onRemove}
          className="inline-flex items-center gap-1.5 rounded-md border border-warm-gray-300 px-2.5 py-1.5 text-xs cursor-pointer hover:bg-warm-gray-100"
        >
          <Trash2 className="size-3.5" />
          Fjern
        </button>
      </div>

      <div className="mt-3 grid gap-2.5">
        <ImportGradeRow
          label="Karakter"
          value={item.grade}
          onChange={(value) => onUpdate({ grade: value })}
        />
        {item.exam > 0 ? (
          <ImportGradeRow
            label="Eksamenskarakter"
            value={item.exam}
            onChange={(value) =>
              onUpdate({
                exam: value,
                exam2: value === 0 ? 0 : item.exam2,
              })
            }
          />
        ) : (
          <AddExamButton
            label="Legg til eksamenskarakter"
            onClick={() =>
              onUpdate({
                exam: 3,
                exam2: 0,
              })
            }
          />
        )}
        {item.exam > 0 &&
          (item.exam2 > 0 ? (
            <ImportGradeRow
              label="Eksamenskarakter 2"
              value={item.exam2}
              onChange={(value) => onUpdate({ exam2: value })}
            />
          ) : (
            <AddExamButton
              label="Legg til eksamenskarakter 2"
              onClick={() => onUpdate({ exam2: 3 })}
            />
          ))}
      </div>
    </div>
  )
}
